/*
 * Social sharing
 * @author: Elton Jain
*/

define('modules/common/Sharer',[
    'jquery',
    'Helper'
], function ($, Helper) {
    "use strict";

    var platforms = {
        facebook: {
            url: 'https://www.facebook.com/sharer/sharer.php?u=',
            // url: 'http://www.facebook.com/sharer/sharer.php?s=100&p[url]=" + encodeURI(http://yahoo.com) + "&p[images][0]=" + encodeURI(fbimgurl) + "&p[title]=" + encodeURI("asdasdas") + "&p[summary]=" + encodeURI(fbsummary)',
            callback: function (url) {
                url = this.url + url;
                Helper.newWindow(url);
            }
        },
        google: {
            url: 'https://plus.google.com/share?url=',
            callback: function (url) {
                url = this.url + url;
                Helper.newWindow(url);
            }
        },
        whatsapp: {
            url: 'whatsapp://send?text=',
            callback: function (url) {
                url = this.url + url;
                Helper.newWindow(url);
            }
        },
        email: {
            url: 'mailto:?&subject=&body=',
            callback: function (url, title, image,description) {
                var newUrl = 'mailto:?&subject=' + title + '&body=' + description + url;
                Helper.newWindow(newUrl);
            }
        }
    };

    return {
        share: function (platform, url, title, image, description) {

            if(platforms && platforms[platform]) {
                platforms[platform].callback(url, title, image, description);
            }
        }
    };
});
